import { onAddressChangedEvent } from '../../Shared/React/js/components/addressSearch/AddressSearch';

(function () {
    'use strict';
    var promise = null;

    function main() {
        function updateQueryConnection(queryString, connections) {
            if (connections && connections.length) {
                return WhistleOut.updateQueryStringParameter(queryString, 'connection', connections);
            }
            return queryString;
        }

        /**
         * Resolve the speed / maxspeed values to emit on the outgoing search URL based on the
         * currently-selected speed option in the widget. Range semantics mirror
         * FormatHelper.GetSpeedRanges:
         *   - Any range        (min===0 && max===0): emit neither
         *   - Open-ended "N+"  (max<0):              emit speed only
         *   - First "0-N"      (min===0 && max>0):   emit maxspeed only (speed=0 is meaningless)
         *   - Otherwise:                              emit both
         */
        function getSelectedSpeedRange(widget) {
            var selectedSpeedOption = widget.find('[data-speed-select] option:selected');
            if (!selectedSpeedOption.length) {
                return { speed: null, maxspeed: null };
            }
            var minspeed = parseInt(selectedSpeedOption.data('min'), 10);
            var maxspeed = parseInt(selectedSpeedOption.data('max'), 10);
            if (isNaN(minspeed)) minspeed = null;
            if (isNaN(maxspeed)) maxspeed = null;

            var isAnyRange = minspeed === 0 && maxspeed === 0;
            if (isAnyRange) {
                return { speed: null, maxspeed: null };
            }
            var isOpenEnded = maxspeed !== null && maxspeed < 0;
            var emitSpeed = minspeed !== null && minspeed > 0;
            var emitMaxspeed = !isOpenEnded && maxspeed !== null && maxspeed > 0;
            return {
                speed: emitSpeed ? minspeed : null,
                maxspeed: emitMaxspeed ? maxspeed : null
            };
        }

        var controller = {
            init: function () {
                var widgets = wo$('[data-widget-type="broadband-search-form"]');
                if (!widgets.length) return;

                var selectValuesFromQuery = function (widget) {
                    var query = decodeURIComponent(wo$(widget).data('query'));

                    var address = WhistleOut.getQueryStringParameter('address', query);
                    if (address) {
                        wo$(widget).find('input[data-address-input]').val(address);
                    }

                    var data = WhistleOut.getQueryStringParameter('data', query);
                    if (data) {
                        wo$(widget)
                            .find('select[data-data-select] option[value="' + data + '"]')
                            .prop('selected', true);
                    }

                    var speed = WhistleOut.getQueryStringParameter('speed', query);
                    if (speed) {
                        // Speed <option> values now encode a range ("<min>-<max>"), so we cannot
                        // match by exact value. Find the range that contains the inbound speed:
                        // min <= speed <= max, with max < 0 representing the open-ended "N+" range.
                        var parsedSpeed = parseInt(speed, 10);
                        if (!isNaN(parsedSpeed)) {
                            wo$(widget)
                                .find('select[data-speed-select] option')
                                .each(function () {
                                    var min = parseInt(wo$(this).data('min'), 10);
                                    var max = parseInt(wo$(this).data('max'), 10);
                                    if (isNaN(min)) return;
                                    if (parsedSpeed >= min && (max < 0 || parsedSpeed <= max)) {
                                        wo$(this).prop('selected', true);
                                        return false; // break out of .each()
                                    }
                                });
                        }
                    }
                };

                for (var index = 0; index < widgets.length; index++) {
                    selectValuesFromQuery(widgets[index]);
                }

                widgets.off('click');
                widgets.on('click', '[data-search-button]', function () {
                    controller.search(wo$(this));
                });

                addEventListener(onAddressChangedEvent, function () {
                    var widget = wo$(this).find('[data-widget-type="broadband-search-form"]');
                    if (
                        widget.data('auto-fill-address') === 'True' &&
                        widget.data('mode') === 'Express' &&
                        widget.find('[data-address-input]').val() !== ''
                    ) {
                        controller.search(wo$(this).find('[data-search-button]'));
                    }
                });
            },

            checkCoverage: function (url, address, widget) {
                promise = new Promise(function (resolve) {
                    var useDefaultSuppliers = false;
                    var transactUrl = '';
                    var supplierName = '';
                    var supplierImageUrl = '';
                    if (address) {
                        url = WhistleOut.updateQueryStringParameter(url, 'address', address);
                        wo$.ajax({
                            url: url,
                            type: 'GET',
                            success: function (result) {
                                if (result) {
                                    WhistleOut.setCoverageCookie(result.coverage);
                                    useDefaultSuppliers = result.useDefaultSuppliers;
                                    if (widget.data('mode') === 'Express') {
                                        transactUrl = result.transactUrl;
                                        supplierName = result.supplierName;
                                        supplierImageUrl = result.supplierImageUrl;
                                    }
                                }
                                return resolve({
                                    useDefaultSuppliers: useDefaultSuppliers,
                                    transactUrl: transactUrl,
                                    supplierName: supplierName,
                                    supplierImageUrl: supplierImageUrl
                                });
                            }
                        });
                    } else {
                        return resolve({
                            useDefaultSuppliers: false,
                            transactUrl: '',
                            supplierName: '',
                            supplierImageUrl: ''
                        });
                    }
                });
            },

            search: function ($this) {
                $this.find('.fa-spinner').show();

                WhistleOut.trackEvent('BroadbandSearchForm', 'Search');

                var widget = $this.parents('[data-widget-type="broadband-search-form"]');
                var coverageUrl = widget.data('coverageurl');
                var address = widget.find('[data-address-input]').val();
                controller.checkCoverage(coverageUrl, address, widget);

                var searchUrl = widget.data('searchurl');
                var defaultSuppliers = widget.data('defaultsuppliers');
                var defaultConnections = widget.data('defaultconnections');
                var detectLocation = widget.data('detectlocation');
                var initialQueryParams = widget.data('query');
                var maxResultsPerSupplier = widget.data('maxresultspersupplier');
                var monetised = widget.data('monetised');
                var data = widget.find('[data-data-select]').val();

                var queryString = '';

                if (initialQueryParams) {
                    queryString = decodeURIComponent(initialQueryParams);
                    if (queryString.indexOf('?') === -1) queryString = '?' + queryString;
                }

                queryString = WhistleOut.updateQueryStringParameter(
                    queryString,
                    'maxresultspersupplier',
                    maxResultsPerSupplier
                );
                queryString = WhistleOut.updateQueryStringParameter(queryString, 'monetised', monetised);

                var dataValue = data || data === 0 ? data : null;
                queryString = WhistleOut.updateQueryStringParameter(queryString, 'data', dataValue);

                var speedRange = getSelectedSpeedRange(widget);
                queryString = WhistleOut.updateQueryStringParameter(queryString, 'speed', speedRange.speed);
                queryString = WhistleOut.updateQueryStringParameter(queryString, 'maxspeed', speedRange.maxspeed);

                queryString = WhistleOut.updateQueryStringParameter(queryString, 'tab', null);

                if (address && address.length) {
                    queryString = WhistleOut.updateQueryStringParameter(
                        queryString,
                        'address',
                        address.replace(/\s+/g, '+')
                    );
                    controller.executeSearch(widget, searchUrl, queryString, defaultSuppliers);
                } else if (detectLocation === true || detectLocation === 'True') {
                    WhistleOut.getCurrentLocation(
                        function (e) {
                            var address = e.label;
                            if (address && address.length > 1) {
                                queryString = WhistleOut.updateQueryStringParameter(
                                    queryString,
                                    'address',
                                    address.replace(/\s+/g, '+')
                                );
                            } else if (defaultConnections && defaultConnections.length) {
                                queryString = updateQueryConnection(queryString, defaultConnections);
                            }
                            controller.executeSearch(widget, searchUrl, queryString, defaultSuppliers);
                        },
                        function () {
                            queryString = updateQueryConnection(queryString, defaultConnections);
                            controller.executeSearch(widget, searchUrl, queryString, defaultSuppliers);
                        }
                    );
                } else {
                    queryString = updateQueryConnection(queryString, defaultConnections);
                    controller.executeSearch(widget, searchUrl, queryString, defaultSuppliers);
                }
            },

            executeSearch: function (widget, url, queryString, defaultSuppliers) {
                if (promise) {
                    promise
                        .then(function (result) {
                            if (result.transactUrl) {
                                widget.find('[data-supplier-name]').html(result.supplierName);
                                widget.find('[data-supplier-image]').attr('src', result.supplierImageUrl);
                                widget.find('[data-heading], [data-form]').hide();
                                widget.find('[data-transact-heading], [data-transact-status]').show();
                                setTimeout(function () {
                                    controller.openSearchWindow(result.transactUrl);
                                }, 3000);
                            } else {
                                if (result.useDefaultSuppliers && defaultSuppliers && defaultSuppliers.length) {
                                    queryString = WhistleOut.updateQueryStringParameter(
                                        queryString,
                                        'supplier',
                                        defaultSuppliers
                                    );
                                }
                                controller.openSearchWindow(url + queryString);
                            }
                        })
                        .catch(function () {
                            controller.openSearchWindow(url + queryString);
                        });
                } else {
                    controller.openSearchWindow(url + queryString);
                }
            },

            openSearchWindow: function (url) {
                var win = window.open(url, '_top');
                win.focus();
            }
        };

        WhistleOut.initWidget = controller.init;
        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
